import { render, staticRenderFns } from "./addClassNotice.vue?vue&type=template&id=7f42bd58&"
import script from "./addClassNotice.vue?vue&type=script&lang=js&"
export * from "./addClassNotice.vue?vue&type=script&lang=js&"
import style0 from "./addClassNotice.vue?vue&type=style&index=0&id=7f42bd58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports